import { render } from "./opacityBg.vue?vue&type=template&id=529b84b8"
import script from "./opacityBg.vue?vue&type=script&lang=js"
export * from "./opacityBg.vue?vue&type=script&lang=js"

import "./opacityBg.vue?vue&type=style&index=0&id=529b84b8&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__